// extracted by mini-css-extract-plugin
export var aniSpin = "ImageLayout-module--ani-spin--rLmmP";
export var black = "#000";
export var el = "ImageLayout-module--el--r5dHK";
export var el__image = "ImageLayout-module--el__image--Q1w0q";
export var el__inner = "ImageLayout-module--el__inner--1TSzT";
export var el__item = "ImageLayout-module--el__item--1bYQ3";
export var largeDesktop = "1400px";
export var largePhone = "480px";
export var mediumDesktop = "1300px";
export var smallDesktop = "1100px";
export var smallPhone = "320px";
export var tabletLandscape = "1024px";
export var tabletPortrait = "768px";
export var white = "#fff";
export var xlDesktop = "1600px";
export var xxlDesktop = "1900px";
export var xxxlDesktop = "2150px";